import { AxiosResponse } from "axios";
import api from "../../Axios/middleware";
import { call, put } from "redux-saga/effects";
import {
  bookletMaterialRead,
  failureBookletMaterialRead,
  successBookletMaterialRead,
} from "./Admin/BookletMaterial/BookletMaterialRead";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  bookletMaterialCreate,
  failureBookletMaterialCreate,
  successBookletMaterialCreate,
} from "./Admin/BookletMaterial/BookletMaterialCreate";
import {
  failureBookletRequestRead,
  successBookletRequestRead,
} from "./Admin/BookletRequest/BookletRequestRead";
import {
  failureBookletRequestDecision,
  successBookletRequestDecision,
} from "./Admin/BookletRequest/BookletRequestDecision";
import {
  failureBookletRequestDecisionRead,
  successBookletRequestDecisionRead,
} from "./Admin/BookletRequest/BookletRequestDecisionRead";
import {
  failureCentreMasterRead,
  successCentreMasterRead,
} from "./Admin/CentreMaster/CentreMatserRead";
import {
  failureCentreMasterCreate,
  successCentreMasterCreate,
} from "./Admin/CentreMaster/CentreMasterCreate";
import {
  failureCentreMasterMappingCreate,
  successCentreMasterMappingCreate,
} from "./Admin/CentreMasterMapping/CentreMasterMappingCreate";
import {
  failurePrinterCreate_Update,
  successPrinterCreate_Update,
} from "./Admin/PrinterMaster/PrinterMasterCreate_Update";
import {
  failurePrinterMasterRead,
  successPrinterMasterRead,
} from "./Admin/PrinterMaster/PrinterMasterRead";
import {
  failureTutorsRead,
  successTutorsRead,
} from "./Admin/Tutors/TutorsRead";
import {
  failureCommonFilter,
  successCommonFilter,
} from "./CommonFilter/CommonFilter";
import {
  failureStudyMaterialRead,
  successStudyMaterialRead,
} from "./Tutor/StudyMaterial/StudyMaterialRead";
import {
  failureStudyMaterialAddToCartCreate,
  successStudyMaterialAddToCartCreate,
} from "./Tutor/StudyMaterial/StudyMaterialAddToCartCreate";
import {
  failureStudyMaterialRequestCreate,
  successStudyMaterialRequestCreate,
} from "./Tutor/StudyMaterial/StudyMaterialRequestCreate";
import {
  failureLessonPlanRead,
  successLessonPlanRead,
} from "./Tutor/LessonPlan/LessonPlanRead";
import {
  failureMyRequestRead,
  successMyRequestRead,
} from "./Tutor/MyRequest/MyRequestRead";
import {
  failureCentreMasterUpdate,
  successCentreMasterUpdate,
} from "./Admin/CentreMaster/CentreMasterUpdate";
import {
  failureCentreMasterDelete,
  successCentreMasterDelete,
} from "./Admin/CentreMaster/CentreMasterDelete";
import { ICenter } from "../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/ICenter";
import { ICenterPrinter } from "../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center_Printer/ICenterPrinter";
import {
  failureCentreMasterMappingRead,
  successCentreMasterMappingRead,
} from "./Admin/CentreMasterMapping/CentreMatserMappingRead";
import {
  failureStudyMaterialCartRead,
  successStudyMaterialCartRead,
} from "./Tutor/StudyMaterial/StudyMaterialCartRead";
import {
  failureStudyMaterialReadById,
  successStudyMaterialReadById,
} from "./Tutor/StudyMaterial/StudyMaterialReadById";
import {
  failureStudyMaterialPreview,
  successStudyMaterialPreview,
} from "./Tutor/StudyMaterial/StudyMaterialPreview";
import {
  failureCentreMasterLocation,
  successCentreMasterLocation,
} from "./Admin/CentreMaster/CentreMatserLocation";
import {
  failurePrinterOptions,
  successPrinterOptions,
} from "./Tutor/PrinterOptions/PrinterOptions";
import { failureRolesRead, successRolesRead } from "./Admin/Tutors/RoleRead ";
import {
  failureTutorCreate_Update,
  successTutorCreate_Update,
} from "./Admin/Tutors/TutorsCreate_Update";
import {
  failureDefaultPrinter,
  successDefaultPrinter,
} from "./Tutor/PrinterOptions/DefaultPrinter";
import {
  failureSubject_Drive_MapCreate_Update,
  successSubject_Drive_MapCreate_Update,
} from "./Admin/Subject_drive_map/SubjectFolderDriveMasterCreate_Update";
import {
  failureSubject_Drive_MapMasterRead,
  successSubject_Drive_MapMasterRead,
} from "./Admin/Subject_drive_map/SubjectDriveMapMasterRead";
import {
  failureSubjectFolderMasterRead,
  successSubjectFolderMasterRead,
} from "./Admin/Subject_drive_map/SubjectFolderRead";
import {
  failureClassSelectionMasterRead,
  successClassSelectionMasterRead,
} from "./Admin/ClassSelectionMaster/ClassSelectionMasterRead";
import {
  failureClassSelectionCreate_Update,
  successClassSelectionCreate_Update,
} from "./Admin/ClassSelectionMaster/ClassSelectionMasterCreate_Update";
import {
  failureClassSelectionSubjectRead,
  successClassSelectionSubjectRead,
} from "./Admin/ClassSelectionMaster/ClassSelectionSubjectRead";
import {
  failureClassYeargroupRead,
  successClassYeargroupRead,
} from "./Tutor/ClassSelection/ClassYeargroup";
import {
  failureClassSubjectRead,
  successClassSubjectRead,
} from "./Tutor/ClassSelection/ClassSubject";
import {
  failureClassDrive_fileRead,
  successClassDrive_fileRead,
} from "./Tutor/ClassSelection/ClassDriveFile";
import {
  failureTutorDashboardStatusRead,
  successTutorDashboardStatusRead,
} from "./Tutor/Dashboard/DashboardStatus";
import {
  failureTutorDashboardSummaryRead,
  successTutorDashboardSummaryRead,
} from "./Tutor/Dashboard/DashboardSummary";
import {
  failureTutorDashboardClassesRead,
  successTutorDashboardClassesRead,
} from "./Tutor/Dashboard/DashboardAssignedClasses";
import {
  failureTutorAdminDashboardRead,
  successTutorAdminDashboardRead,
} from "./Admin/DashboardData/Dashboarddata";
import { failureReprint, successReprint } from "./Tutor/Reprint/Reprint";
import {
  failureAiDriveSearch,
  successAiDriveSearch,
} from "./Tutor/AiSearch/AiSearch";
import {
  failurePrinterList,
  successPrinterList,
} from "./Tutor/PrinterOptions/Printlist";
import {
  failurePrinterChange,
  successPrinterChange,
} from "./Tutor/PrinterOptions/PrinterChange";
import {
  failureDefaultPrinterUpdate,
  successDefaultPrinterUpdate,
} from "./Tutor/PrinterOptions/DefaultPrinterChange";
import {
  failureClassSelectionDataRead,
  successClassSelectionDataRead,
} from "./Tutor/ClassSelection/Class selection page/ClassSelectionData";
import {
  failurePreviousClassRead,
  successPreviousClassRead,
} from "./Tutor/ClassSelection/Class selection page/PreviousClassRead";
import {
  failurePreviousClass_CRUDRead,
  successPreviousClass_CRUDRead,
} from "./Tutor/ClassSelection/Class selection page/PreviousClass_CRUD";
import {
  failureDashboardPrintlist,
  successDashboardPrintlist,
} from "./Tutor/PrinterOptions/DashboardPrintlist";
import {
  failureTutorDashboardCalendar,
  successTutorDashboardCalendar,
} from "./Tutor/Dashboard/DashbaoardCalender";
import {
  failureTutoradmin_Calendar,
  successTutoradmin_Calendar,
} from "./Admin/CalenderView/CalenderView";
import {
  failureReportList,
  successReportList,
} from "./Admin/Report/ReportList";
import {
  failureReportReprint,
  successReportReprint,
} from "./Admin/Report/ReportReprint";
import {
  failureReportFilter,
  successReportFilter,
} from "./Admin/Report/ReportFilter";
import {
  failureClassCenterRead,
  successClassCenterRead,
} from "./Tutor/ClassSelection/ClassCenter";
import {
  failureTutorReportList,
  successTutorReportList,
} from "./Tutor/Report/TutorReportList";
import {
  failureTutorReportFilter,
  successTutorReportFilter,
} from "./Tutor/Report/TutorReportFilter";
import {
  failureStudyMaterialCartCount,
  successStudyMaterialCartCount,
} from "./Tutor/StudyMaterial/StudyMaterialCartCount";

//#region Admin Module

//#region Booklet Material

// Read Booklet Material
const BookletMaterialReadApi = (action?: PayloadAction<any>) => {
  return api.post("", action?.payload);
};

export function* BookletMaterialReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(BookletMaterialReadApi, action);
    yield put(successBookletMaterialRead(response.data));
  } catch (error) {
    yield put(failureBookletMaterialRead(error));
  }
}

// Create and Update Booklet Material
const BookletMaterialCreate_UpdateApi = (action: PayloadAction<any>) => {
  return api.post("", action.payload);
};

export function* BookletMaterialCreate_UpdateCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(
      BookletMaterialCreate_UpdateApi,
      action
    );
    yield put(successBookletMaterialCreate(response.data));
  } catch (error) {
    yield put(failureBookletMaterialCreate(error));
  }
}
//#endregion Booklet Material

//#region Booklet Request

// Read Booklet Request
const BookletRequestReadApi = (action?: PayloadAction<any>) => {
  const request_id = action?.payload?.request_id;
  return api.get(`/api/booklet/request/view/${request_id}`, action?.payload);
};

export function* BookletRequestReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(BookletRequestReadApi, action);
    yield put(successBookletRequestRead(response.data));
  } catch (error) {
    yield put(failureBookletRequestRead(error));
  }
}

const BookletRequestDecisionReadApi = (req_ids?: string[]) => {
  return api.get("/api/booklet/request/allrequest", {
    params: req_ids && req_ids.length > 0 ? { req_ids } : {},
    paramsSerializer: (params) => {
      if (!params.req_ids) return "";
      return params.req_ids
        .map((id: string) => `req_ids=${encodeURIComponent(id)}`)
        .join("&");
    },
  });
};

export function* BookletRequestDecisionReadCall(
  action: PayloadAction<{ req_ids?: string[] }>
) {
  try {
    const response: AxiosResponse = yield call(
      BookletRequestDecisionReadApi,
      action.payload?.req_ids
    );
    yield put(successBookletRequestDecisionRead(response.data));
  } catch (error) {
    yield put(failureBookletRequestDecisionRead(error));
  }
}

// Decision Booklet Request
const BookletRequestDecisionApi = (action: PayloadAction<any>) => {
  return api.put("/api/booklet/request/accept", action.payload);
};

export function* BookletRequestDecisionCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(
      BookletRequestDecisionApi,
      action
    );
    yield put(successBookletRequestDecision(response.data));
  } catch (error) {
    yield put(failureBookletRequestDecision(error));
  }
}

//#endregion Booklet Request

//#region Centre Master

// Read Centre Master
const CentreMasterReadApi = () => {
  return api.get("/api/booklet/center/get");
};

export function* CentreMasterReadCall() {
  try {
    const response: AxiosResponse = yield call(CentreMasterReadApi);
    yield put(successCentreMasterRead(response.data));
  } catch (error) {
    yield put(failureCentreMasterRead(error));
  }
}

// Read Centre Master
const CentreMasterLocationApi = () => {
  return api.get("/api/booklet/center/location");
};

export function* CentreMasterLocationCall() {
  try {
    const response: AxiosResponse = yield call(CentreMasterLocationApi);
    yield put(successCentreMasterLocation(response.data));
  } catch (error) {
    yield put(failureCentreMasterLocation(error));
  }
}

// Create, Update, Delete Centre Master
const CentreMasterCreate_Api = (action: PayloadAction<ICenter>) => {
  return api.post("/api/booklet/center/create", action.payload);
};

export function* CentreMasterCreate_Call(action: PayloadAction<ICenter>) {
  try {
    const response: AxiosResponse = yield call(CentreMasterCreate_Api, action);
    yield put(successCentreMasterCreate(response.data));
  } catch (error) {
    yield put(failureCentreMasterCreate(error));
  }
}

const CentreMaster_Update_Api = (id: number | string, data: ICenter) => {
  return api.put(`/api/booklet/center/update/${id}`, data);
};

export function* CentreMaster_Update_ApiCall(
  action: PayloadAction<{ id: number | string }>
) {
  try {
    const { id, ...payload } = action.payload; // extract id
    const response: AxiosResponse = yield call(
      CentreMaster_Update_Api,
      id,
      payload
    );
    yield put(successCentreMasterUpdate(response.data));
  } catch (error) {
    yield put(failureCentreMasterUpdate(error));
  }
}

const CentreMaster_Delete_Api = (id: number | string) => {
  return api.delete(`/api/booklet/center/delete/${id}`);
};

export function* CentreMaster_DeleteCall(
  action: PayloadAction<{ id: number | string }>
) {
  try {
    const { id } = action.payload;
    const response: AxiosResponse = yield call(CentreMaster_Delete_Api, id);
    yield put(successCentreMasterDelete(response.data));
  } catch (error) {
    yield put(failureCentreMasterDelete(error));
  }
}

//#endregion Centre Master

//#region Centre Master Mapping

//Read Centre Master Mapping
const CentreMasterMappingReadApi = () => {
  return api.post("/api/booklet/center_printer_mapping/get");
};

export function* CentreMasterMappingReadCall() {
  try {
    const response: AxiosResponse = yield call(CentreMasterMappingReadApi);
    yield put(successCentreMasterMappingRead(response.data));
  } catch (error) {
    yield put(failureCentreMasterMappingRead(error));
  }
}

// Create, Update, Delete Centre Master Mapping
const CentreMasterMappingCreate_Update_DeleteApi = (
  action: PayloadAction<ICenterPrinter>
) => {
  return api.post(
    "/api/booklet/center_printer_mapping/create_edit",
    action.payload
  );
};

export function* CentreMasterMappingCreate_Update_DeleteCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      CentreMasterMappingCreate_Update_DeleteApi,
      action
    );
    yield put(successCentreMasterMappingCreate(response.data));
  } catch (error) {
    yield put(failureCentreMasterMappingCreate(error));
  }
}

//#endregion Centre Master Mapping

//#region Printer Master
//Read Printer Master
const PrinterMasterReadApi = () => {
  return api.post("/api/booklet/printer/get");
};

export function* PrinterMasterReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(PrinterMasterReadApi);
    yield put(successPrinterMasterRead(response.data));
  } catch (error) {
    yield put(failurePrinterMasterRead(error));
  }
}

// Create, Update, Delete Printer Master
const PrinterMasterCreate_Update_DeleteApi = (action: PayloadAction<any>) => {
  return api.post("/api/booklet/printer/create_edit", action.payload);
};

export function* PrinterMasterCreate_Update_DeleteCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      PrinterMasterCreate_Update_DeleteApi,
      action
    );
    yield put(successPrinterCreate_Update(response.data));
  } catch (error) {
    yield put(failurePrinterCreate_Update(error));
  }
}

const PrinterChangeApi = (action: PayloadAction<any>) => {
  return api.put("/api/booklet/request/tutor_update", action.payload);
};

export function* PrinterChangeCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(PrinterChangeApi, action);
    yield put(successPrinterChange(response.data));
  } catch (error) {
    yield put(failurePrinterChange(error));
  }
}
//#endregion Printer Master

//#region Tutors Master

//Read Tutors Master
const RoleReadApi = () => {
  return api.get(`/api/booklet/tutor/role`);
};

export function* RoleReadCall() {
  try {
    const response: AxiosResponse = yield call(RoleReadApi);
    yield put(successRolesRead(response.data));
  } catch (error) {
    yield put(failureRolesRead(error));
  }
}

const TutorsMasterReadApi = (role: string) => {
  return api.get(`/api/booklet/tutor/?role=${role}`);
};

export function* TutorsMasterReadCall(
  action?: PayloadAction<{ role: string }>
) {
  try {
    const role = action?.payload?.role ?? "TUTOR";
    const response: AxiosResponse = yield call(TutorsMasterReadApi, role);
    yield put(successTutorsRead(response.data));
  } catch (error) {
    yield put(failureTutorsRead(error));
  }
}

const TutorMasterCreate_Update_DeleteApi = (action: PayloadAction<any>) => {
  return api.post("/api/booklet/tutor/create_or_update", action.payload);
};

export function* TutorMasterCreate_Update_DeleteCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      TutorMasterCreate_Update_DeleteApi,
      action
    );
    yield put(successTutorCreate_Update(response.data));
  } catch (error) {
    yield put(failureTutorCreate_Update(error));
  }
}

//#endregion Tutors Master

//#endregion Admin Module

//#region Common Filter

// Filter For Admin and Tutor Module
const CommonFilterApi = (action?: PayloadAction<any>) => {
  return api.post("", action?.payload);
};

export function* CommonFilterApiCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(CommonFilterApi, action);
    yield put(successCommonFilter(response.data));
  } catch (error) {
    yield put(failureCommonFilter(error));
  }
}

//#endregion Common Filter

//#region Tutor Module

//#region Study Material

// Read Study Material
const StudyMaterialReadApi = () => {
  return api.get("/api/booklet/dashboard/get");
};

export function* StudyMaterialReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(StudyMaterialReadApi);
    yield put(successStudyMaterialRead(response.data));
  } catch (error) {
    yield put(failureStudyMaterialRead(error));
  }
}

const StudyMaterialPreviewApi = (id: number | string) => {
  return api.get(`/api/booklet/dashboard/preview?file_id=${id}`);
};

export function* StudyMaterialPreviewCall(
  action: PayloadAction<{ id: number | string }>
) {
  try {
    const { id } = action.payload;
    const response: AxiosResponse = yield call(StudyMaterialPreviewApi, id);
    yield put(successStudyMaterialPreview(response.data));
  } catch (error) {
    yield put(failureStudyMaterialPreview(error));
  }
}

const StudyMaterialReadByIdApi = (item_id: number | string) => {
  return api.get(`/api/booklet/dashboard/filtered?item_id=${item_id}`);
};

export function* StudyMaterialReadByIdCall(
  action: PayloadAction<{ item_id: number | string }>
) {
  try {
    const { item_id } = action.payload;
    const response: AxiosResponse = yield call(
      StudyMaterialReadByIdApi,
      item_id
    );
    yield put(successStudyMaterialReadById(response.data));
  } catch (error) {
    yield put(failureStudyMaterialReadById(error));
  }
}

// Read Study Material Cart
const StudyMaterialCartReadApi = () => {
  return api.get("/api/booklet/dashboard/cart_list");
};

export function* StudyMaterialCartReadCall() {
  try {
    const response: AxiosResponse = yield call(StudyMaterialCartReadApi);
    yield put(successStudyMaterialCartRead(response.data));
  } catch (error) {
    yield put(failureStudyMaterialCartRead(error));
  }
}

const StudyMaterialCartCountApi = () => {
  return api.get("/api/booklet/dashboard/cart/count");
};

export function* StudyMaterialCartCountCall() {
  try {
    const response: AxiosResponse = yield call(StudyMaterialCartCountApi);
    yield put(successStudyMaterialCartCount(response.data));
  } catch (error) {
    yield put(failureStudyMaterialCartCount(error));
  }
}

// Add To Cart Study Material
const StudyMaterialAddToCartApi = (action: PayloadAction<any>) => {
  return api.post("/api/booklet/dashboard/cart", action.payload);
};

export function* StudyMaterialAddToCartCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(
      StudyMaterialAddToCartApi,
      action
    );
    yield put(successStudyMaterialAddToCartCreate(response.data));
  } catch (error) {
    yield put(failureStudyMaterialAddToCartCreate(error));
  }
}

// Request Create Study Material
const StudyMaterialRequestCreateApi = (action: PayloadAction<any>) => {
  return api.post("/api/booklet/request/add", action.payload);
};

export function* StudyMaterialRequestCreateCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(
      StudyMaterialRequestCreateApi,
      action
    );
    yield put(successStudyMaterialRequestCreate(response.data));
  } catch (error) {
    yield put(failureStudyMaterialRequestCreate(error));
  }
}
//#endregion Study Material

//#region Lesson Plan

//Read Lesson Plan
const LessonPlanReadApi = () => {
  return api.get("/api/booklet/lesson/drive_data");
};

export function* LessonPlanReadCall() {
  try {
    const response: AxiosResponse = yield call(LessonPlanReadApi);
    yield put(successLessonPlanRead(response.data));
  } catch (error) {
    yield put(failureLessonPlanRead(error));
  }
}

//#endregion

//#region My Request

// Read My Request
const MyRequestReadApi = (req_ids?: string[]) => {
  return api.get("/api/booklet/request/list", {
    params: req_ids && req_ids.length > 0 ? { req_ids } : {},
    paramsSerializer: (params) => {
      if (!params.req_ids) return "";
      return params.req_ids
        .map((id: string) => `req_ids=${encodeURIComponent(id)}`)
        .join("&");
    },
  });
};

export function* MyRequestReadCall(
  action: PayloadAction<{ req_ids?: string[] }>
) {
  try {
    const response: AxiosResponse = yield call(
      MyRequestReadApi,
      action.payload?.req_ids
    );
    yield put(successMyRequestRead(response.data));
  } catch (error) {
    yield put(failureMyRequestRead(error));
  }
}

//#endregion My Request

// #region Printer OPtions

const PrinterOptionsApi = () => {
  return api.get(`/api/booklet/dashboard/options`);
};

export function* PrinterOptionsCall() {
  try {
    const response: AxiosResponse = yield call(PrinterOptionsApi);
    yield put(successPrinterOptions(response.data));
  } catch (error) {
    yield put(failurePrinterOptions(error));
  }
}

const DefaultPrinterOptionsApi = () => {
  return api.get(`/api/booklet/dashboard/default_printer_settings`);
};

export function* DefaultPrinterOptionsCall() {
  try {
    const response: AxiosResponse = yield call(DefaultPrinterOptionsApi);
    yield put(successDefaultPrinter(response.data));
  } catch (error) {
    yield put(failureDefaultPrinter(error));
  }
}

const PrinterListApi = () => {
  return api.get(`/api/booklet/request/printer_list`);
};

export function* PrinterListCall() {
  try {
    const response: AxiosResponse = yield call(PrinterListApi);
    yield put(successPrinterList(response.data));
  } catch (error) {
    yield put(failurePrinterList(error));
  }
}

const DefaultPrinterOptions_Update_Api = (id: number | string) => {
  return api.get(
    `/api/booklet/request/default_printer_settings?printer_id=${id}`
  );
};

export function* DefaultPrinterOptions_Update_ApiCall(
  action: PayloadAction<{ id: number | string }>
) {
  try {
    const { id } = action.payload; // extract id
    const response: AxiosResponse = yield call(
      DefaultPrinterOptions_Update_Api,
      id
    );
    yield put(successDefaultPrinterUpdate(response.data));
  } catch (error) {
    yield put(failureDefaultPrinterUpdate(error));
  }
}

const DashboardPrintListApi = (center_id: number | string) => {
  return api.get(`/api/booklet/dashboard/printer_list?center_id=${center_id}`);
};

export function* DashboardPrintListCall(
  action: PayloadAction<{ center_id: number | string }>
) {
  try {
    const { center_id } = action.payload;
    const response: AxiosResponse = yield call(
      DashboardPrintListApi,
      center_id
    );
    yield put(successDashboardPrintlist(response.data));
  } catch (error) {
    yield put(failureDashboardPrintlist(error));
  }
}

//#endregion Printer options

// #region Subject drive Map

const Subject_Drive_MapMasterReadApi = () => {
  return api.post("/api/booklet/booklet_folder/get");
};

export function* Subject_Drive_MapMasterReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(Subject_Drive_MapMasterReadApi);
    yield put(successSubject_Drive_MapMasterRead(response.data));
  } catch (error) {
    yield put(failureSubject_Drive_MapMasterRead(error));
  }
}

const Subject_Drive_MapMasterCreate_Update_DeleteApi = (
  action: PayloadAction<any>
) => {
  return api.post("/api/booklet/booklet_folder/create_edit", action.payload);
};

export function* Subject_Drive_MapMasterCreate_Update_DeleteCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      Subject_Drive_MapMasterCreate_Update_DeleteApi,
      action
    );
    yield put(successSubject_Drive_MapCreate_Update(response.data));
  } catch (error) {
    yield put(failureSubject_Drive_MapCreate_Update(error));
  }
}

const SubjectFolderMasterReadApi = () => {
  return api.get("/api/booklet/booklet_folder/get_subjects");
};

export function* SubjectFolderMasterRaedCall() {
  try {
    const response: AxiosResponse = yield call(SubjectFolderMasterReadApi);
    yield put(successSubjectFolderMasterRead(response.data));
  } catch (error) {
    yield put(failureSubjectFolderMasterRead(error));
  }
}

//#endregion Subject drive Map

// #region class selection master

const ClassSelectionMasterReadApi = () => {
  return api.post("/api/booklet/class_selection_master/get");
};

export function* ClassSelectionMasterReadCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(ClassSelectionMasterReadApi);
    yield put(successClassSelectionMasterRead(response.data));
  } catch (error) {
    yield put(failureClassSelectionMasterRead(error));
  }
}

const ClassSelectionMasterCreate_Update_DeleteApi = (
  action: PayloadAction<any>
) => {
  return api.post(
    "/api/booklet/class_selection_master/create_edit",
    action.payload
  );
};

export function* ClassSelectionMasterCreate_Update_DeleteCall(
  action: PayloadAction<any>
) {
  try {
    const response: AxiosResponse = yield call(
      ClassSelectionMasterCreate_Update_DeleteApi,
      action
    );
    yield put(successClassSelectionCreate_Update(response.data));
  } catch (error) {
    yield put(failureClassSelectionCreate_Update(error));
  }
}

const ClassSelectionSubjectReadApi = () => {
  return api.get("/api/booklet/class_selection_master/get_subjects");
};

export function* ClassSelectionSubjectRaedCall() {
  try {
    const response: AxiosResponse = yield call(ClassSelectionSubjectReadApi);
    yield put(successClassSelectionSubjectRead(response.data));
  } catch (error) {
    yield put(failureClassSelectionSubjectRead(error));
  }
}

//#endregion class selection master

// #region Dashboard classslection

const ClassYeargroupReadApi = () => {
  return api.get("/api/booklet/dashboard/yeargroup_regions");
};

export function* ClassyeargroupCall() {
  try {
    const response: AxiosResponse = yield call(ClassYeargroupReadApi);
    yield put(successClassYeargroupRead(response.data));
  } catch (error) {
    yield put(failureClassYeargroupRead(error));
  }
}

const ClassCenterReadApi = () => {
  return api.get("/api/booklet/dashboard/centers");
};

export function* ClassCentereCall() {
  try {
    const response: AxiosResponse = yield call(ClassCenterReadApi);
    yield put(successClassCenterRead(response.data));
  } catch (error) {
    yield put(failureClassCenterRead(error));
  }
}

const ClassSubjectReadApi = (item_id: number | string) => {
  return api.get(
    `/api/booklet/dashboard/subjects?yeargroup_region_id=${item_id}`
  );
};

export function* ClassSubjectCall(
  action: PayloadAction<{ item_id: number | string }>
) {
  try {
    const { item_id } = action.payload;
    const response: AxiosResponse = yield call(ClassSubjectReadApi, item_id);
    yield put(successClassSubjectRead(response.data));
  } catch (error) {
    yield put(failureClassSubjectRead(error));
  }
}

const ClassDrive_fileReadApi = (item_id: number | string) => {
  return api.get(`/api/booklet/dashboard/get_drive_data?subject_id=${item_id}`);
};

export function* ClassDrive_fileCall(
  action: PayloadAction<{ item_id: number | string }>
) {
  try {
    const { item_id } = action.payload;
    const response: AxiosResponse = yield call(ClassDrive_fileReadApi, item_id);
    yield put(successClassDrive_fileRead(response.data));
  } catch (error) {
    yield put(failureClassDrive_fileRead(error));
  }
}

const PreviousClassReadApi = () => {
  return api.post(
    "/api/booklet/class_selection_master/previous_class_selection"
  );
};

export function* PreviousClassReadCall() {
  try {
    const response: AxiosResponse = yield call(PreviousClassReadApi);
    yield put(successPreviousClassRead(response.data));
  } catch (error) {
    yield put(failurePreviousClassRead(error));
  }
}

const PreviousSelection_CRUDApi = (action: PayloadAction<any>) => {
  return api.post(
    "/api/booklet/class_selection_master/previous_class_selection/create_edit",
    action.payload
  );
};

export function* PreviousSelection_CRUDApiCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(
      PreviousSelection_CRUDApi,
      action
    );
    yield put(successPreviousClass_CRUDRead(response.data));
  } catch (error) {
    yield put(failurePreviousClass_CRUDRead(error));
  }
}

const ClassSelectionDataApi = (yeargroup_id?: number | string) => {
  if (yeargroup_id) {
    return api.get(
      `/api/booklet/class_selection_master/dropdown?yeargroup_region_id=${yeargroup_id}`
    );
  }

  return api.get(`/api/booklet/class_selection_master/dropdown`);
};

export function* ClassSlectionDataCall(
  action: PayloadAction<{ yeargroup_id?: number | string } | undefined>
) {
  try {
    const yeargroup_id = action?.payload?.yeargroup_id;

    const response: AxiosResponse = yield call(
      ClassSelectionDataApi,
      yeargroup_id
    );

    yield put(successClassSelectionDataRead(response.data));
  } catch (error) {
    yield put(failureClassSelectionDataRead(error));
  }
}

//#endregion  Dashboard classslection

// region Tutor histroy report

const TutorReportApi = async ({
  center_id,
  day,
  class_csms_id,
}: {
  center_id?: string | number;
  day?: string | number;
  class_csms_id?: string | number;
}) => {
  const params: any = {};

  if (center_id) params.center_id = center_id;
  if (day) params.day = day;
  if (class_csms_id) params.class_csms_id = class_csms_id;

  return api.get("/api/booklet/tutor/report/tutor/print_history", {
    params,
  });
};

export function* TutorReportCall(
  action: PayloadAction<{
    center_id?: number | string;
    day?: number | string;
    class_csms_id?: number | string;
  }>
) {
  try {
    const { center_id, day, class_csms_id } = action.payload;
    const response: AxiosResponse = yield call(TutorReportApi, {
      center_id,
      day,
      class_csms_id,
    });
    yield put(successTutorReportList(response.data));
  } catch (error) {
    yield put(failureTutorReportList(error));
  }
}

const TutorReportFilterApi = async ({
  center_id,
  day,
}: {
  center_id?: string | number;
  day?: string | number;
}) => {
  const params: any = {};

  if (center_id) params.center_id = center_id;
  if (day) params.day = day;

  return api.get("/api/booklet/tutor/report/filters", {
    params,
  });
};

export function* TutorReportFilterCall(
  action: PayloadAction<{ center_id?: number | string; day?: number | string }>
) {
  try {
    const { center_id, day } = action.payload;
    const response: AxiosResponse = yield call(TutorReportFilterApi, {
      center_id,
      day,
    });
    yield put(successTutorReportFilter(response.data));
  } catch (error) {
    yield put(failureTutorReportFilter(error));
  }
}

// #endregion Tutor histroy report

// #region Tutor Dashboard summary
const TutorDashboardStatusReadApi = () => {
  return api.get("/api/booklet/tutor_dashboard/dashboard_status");
};

export function* TutorDashboardStatusCall() {
  try {
    const response: AxiosResponse = yield call(TutorDashboardStatusReadApi);
    yield put(successTutorDashboardStatusRead(response.data));
  } catch (error) {
    yield put(failureTutorDashboardStatusRead(error));
  }
}

const TutorDashboardSummaryReadApi = () => {
  return api.get("/api/booklet/tutor_dashboard/get_tutor_summary");
};

export function* TutorDashboardSummmaryCall() {
  try {
    const response: AxiosResponse = yield call(TutorDashboardSummaryReadApi);
    yield put(successTutorDashboardSummaryRead(response.data));
  } catch (error) {
    yield put(failureTutorDashboardSummaryRead(error));
  }
}

const TutorDashboardClassesReadApi = () => {
  return api.get("/api/booklet/tutor_dashboard/assigned_classes");
};

export function* TutorDashboardClassesCall() {
  try {
    const response: AxiosResponse = yield call(TutorDashboardClassesReadApi);
    yield put(successTutorDashboardClassesRead(response.data));
  } catch (error) {
    yield put(failureTutorDashboardClassesRead(error));
  }
}

const TutorDashboardCalendarApi = () => {
  return api.get("/api/booklet/tutor_dashboard/print_status_by_date");
};

export function* TutorDashboardCalenderCall() {
  try {
    const response: AxiosResponse = yield call(TutorDashboardCalendarApi);
    yield put(successTutorDashboardCalendar(response.data));
  } catch (error) {
    yield put(failureTutorDashboardCalendar(error));
  }
}

//#endregion Tutor Dashboard summary

// region Tutor Admin Dashboard
const TutorAdminDashboardReadApi = (Center_id?: number | string) => {
  if (Center_id) {
    return api.get(
      `/api/booklet/admin_dashboard/assigned_classes?center_id=${Center_id}`
    );
  } else {
    return api.get("/api/booklet/admin_dashboard/assigned_classes");
  }
};

export function* TutorAdminDashboardCall(
  action: PayloadAction<{ Center_id?: number | string }>
) {
  try {
    const { Center_id } = action.payload;
    const response: AxiosResponse = yield call(
      TutorAdminDashboardReadApi,
      Center_id
    );
    yield put(successTutorAdminDashboardRead(response.data));
  } catch (error) {
    yield put(failureTutorAdminDashboardRead(error));
  }
}

const TutorAdminDashboardCalendarApi = async ({
  center_id,
  year,
  month,
}: {
  center_id?: string | number;
  year?: number;
  month?: number;
}) => {
  const params: any = {};

  if (center_id) params.center_id = center_id;
  if (year) params.year = year;
  if (month) params.month = month;

  return api.get("/api/booklet/admin_dashboard/request_calendar", {
    params,
  });
};

export function* TutorAdminDashboardCalenderCall(
  action: PayloadAction<{
    center_id?: number | string;
    year?: number;
    month?: number;
  }>
) {
  try {
    const { center_id, year, month } = action.payload;
    const response: AxiosResponse = yield call(TutorAdminDashboardCalendarApi, {
      center_id,
      year,
      month,
    });
    yield put(successTutoradmin_Calendar(response.data));
  } catch (error) {
    yield put(failureTutoradmin_Calendar(error));
  }
}

const AdminreprintApi = (action: PayloadAction<any>) => {
  return api.post("/api/booklet/request/reprint_request", action.payload);
};

export function* AdminreprintCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(AdminreprintApi, action);
    yield put(successStudyMaterialRequestCreate(response.data));
  } catch (error) {
    yield put(failureStudyMaterialRequestCreate(error));
  }
}
// #endregion Tutor Admin Dashboard

// region Tutor Admin report

const TutorAdminReportApi = async ({
  center_id,
  day,
  class_csms_id,
}: {
  center_id?: string | number;
  day?: string | number;
  class_csms_id?: string | number;
}) => {
  const params: any = {};

  if (center_id) params.center_id = center_id;
  if (day) params.day = day;
  if (class_csms_id) params.class_csms_id = class_csms_id;

  return api.get("/api/booklet/report/admin", {
    params,
  });
};

export function* TutorAdminReportCall(
  action: PayloadAction<{
    center_id?: number | string;
    day?: number | string;
    class_csms_id?: number | string;
  }>
) {
  try {
    const { center_id, day, class_csms_id } = action.payload;
    const response: AxiosResponse = yield call(TutorAdminReportApi, {
      center_id,
      day,
      class_csms_id,
    });
    yield put(successReportList(response.data));
  } catch (error) {
    yield put(failureReportList(error));
  }
}

const TutorAdminReportFilterApi = async ({
  center_id,
  day,
}: {
  center_id?: string | number;
  day?: string | number;
}) => {
  const params: any = {};

  if (center_id) params.center_id = center_id;
  if (day) params.day = day;

  return api.get("/api/booklet/report/filers", {
    params,
  });
};

export function* TutorAdminReportFilterCall(
  action: PayloadAction<{ center_id?: number | string; day?: number | string }>
) {
  try {
    const { center_id, day } = action.payload;
    const response: AxiosResponse = yield call(TutorAdminReportFilterApi, {
      center_id,
      day,
    });
    yield put(successReportFilter(response.data));
  } catch (error) {
    yield put(failureReportFilter(error));
  }
}

const TutorAdminReportReprintApi = (cart_id?: number | string) => {
  if (cart_id) {
    return api.get(`/api/booklet/report/reprint/${cart_id}`);
  }
};

export function* TutorAdminReportReprintCall(
  action: PayloadAction<{ cart_id?: number | string }>
) {
  try {
    const { cart_id } = action.payload;
    const response: AxiosResponse = yield call(
      TutorAdminReportReprintApi,
      cart_id
    );
    yield put(successReportReprint(response.data));
  } catch (error) {
    yield put(failureReportReprint(error));
  }
}
// #endregion  Tutor Admin report

// region Tutor Reprint

const ReprintApi = (request_id?: number | string) => {
  if (request_id) {
    return api.put(`/api/booklet/request/reprint?request_id=${request_id}`);
  }
};

export function* ReprintCall(
  action: PayloadAction<{ request_id?: number | string }>
) {
  try {
    const { request_id } = action.payload;
    const response: AxiosResponse = yield call(ReprintApi, request_id);
    yield put(successReprint(response.data));
  } catch (error) {
    yield put(failureReprint(error));
  }
}

// #endregion Tutor Reprint

// ✅ Use GET request with query params

const AiDriveSearchApi = (query: string, subject_id?: number | string) => {
  return api.get("/api/booklet/search", {
    params: {
      query,
      ...(subject_id !== undefined && { subject_id }),
    },
  });
};

export function* AiDriveSearchCall(
  action: PayloadAction<{ query: string; subject_id?: number | string }>
) {
  try {
    const { query, subject_id } = action.payload;

    const response: AxiosResponse<any> = yield call(
      AiDriveSearchApi,
      query,
      subject_id
    );

    yield put(successAiDriveSearch(response.data));
  } catch (error) {
    yield put(failureAiDriveSearch(error));
  }
}
//#endregion Tutor Module
